<template>
  <v-container>
    <h4>Personal Information</h4>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <v-img
          v-if="image_src"
          lazy-src="https://picsum.photos/id/11/10/6"
          :src="image_src"
          aspect-ratio="1"
          :max-width="300"
          :max-height="300"
          :eager="true"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
        <br>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-file-input
          :rules="[rules.profile_image]"
          accept="image/*"
          placeholder="Select your profile image"
          prepend-icon="mdi-camera"
          ref="image"
          label="Profile image"
          dense
          v-model="personal_information.profile_image"
          @change="updateImage"
        ></v-file-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="personal_information.internal_code"
          label="Code"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="personal_information.firstname"
          label="Name"
          :rules="[rules.require]"
          outlined
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="personal_information.display_name"
          label="Display name/Nickname"
          outlined
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <div>
          <header>Gender</header>
          <v-radio-group
            v-model="personal_information.gender"
            row
          >
            <v-radio
              v-for="(item, i) in gender_list"
              :key="i"
              :label="item.label"
              :value="item.value"
              color="orange"
            ></v-radio>
          </v-radio-group>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <div>
          <div
            :class="[`subtitle-1`]"
          >
            Birthday:
            {{ personal_information.birthdate }}
            <span>
              ({{ age }} y.)
            </span>
            <v-btn
              tile
              outlined
              color="orange"
              @click="displayDatepicker"
            >
              Select date
              <v-icon>mdi-calendar</v-icon>
            </v-btn>
          </div>
          <v-date-picker
            v-if="displayDate"
            v-model="personal_information.birthdate"
            color="orange"
            elevation="8"
            @change="displayDate = false"
          ></v-date-picker>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-row>
          <v-col
            class="no-padding-vertical"
          >
            <v-text-field
              v-model="personal_information.weight"
              type="number"
              label="Weight"
              max="200"
              min="0"
              outlined
              dense
            />
          </v-col>
          <v-col
            class="no-padding-vertical"
          >
            <v-text-field
              v-model="personal_information.height"
              type="number"
              label="Height"
              max="200"
              min="0"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-select
          :items="marriage_status_list"
          item-text="label"
          item-value="value"
          label="Marriage status"
          v-model="personal_information.marriage_status"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-select
          :items="nationality_list"
          item-text="label"
          item-value="value"
          label="Nationality"
          v-model="personal_information.nationality"
          outlined
          dense
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-select
          :items="religion_list"
          item-text="label"
          item-value="value"
          label="Religion"
          v-model="religion"
          outlined
          dense
          @change="updateReligion"
        ></v-select>
        <v-text-field
          v-if="this.displayReligion"
          v-model="personal_information.religion"
          outlined
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        v-if="personal_information.nationality == 'Thai'"
      >
        <v-text-field
          v-model="personal_information.personal_id"
          label="Personal ID (Thai)"
          outlined
          dense
          :rules="[rules.personal_id]"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        v-if="personal_information.nationality && personal_information.nationality != 'Thai'"
      >
        <v-text-field
          v-model="personal_information.passport_id"
          label="Passport ID (International)"
          outlined
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
          v-if="personal_information.nationality && personal_information.nationality != 'Thai'"
      >
        <v-checkbox
          v-model="personal_information.work_permit"
          label="Working permit"
          color="orange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        v-if="personal_information.nationality && personal_information.nationality != 'Thai' && personal_information.work_permit"
      >
        <div>
          <div
            :class="[`subtitle-1`]"
          >
            Work permit expiration date:
            {{ personal_information.work_permit_expiration_date }}
            <v-btn
              tile
              outlined
              color="orange"
              @click="displayExpirationDate"
            >
              Select date
              <v-icon>mdi-calendar</v-icon>
            </v-btn>
          </div>
          <v-date-picker
            v-if="displayExpireDate"
            v-model="expiration_date"
            color="orange"
            elevation="8"
            @change="updateExpireDate"
          ></v-date-picker>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-checkbox
          v-model="personal_information.driving_license"
          label="Driving license"
          color="orange"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-checkbox
          v-model="personal_information.motorbike_driving_license"
          label="Motorbike driving license"
          color="orange"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-checkbox
          v-model="personal_information.vaccine"
          label="Vaccine"
          color="orange"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers'
export default {
  name: 'PersonalInformation',
  components: { },
  props: ['personal_information', 'image_src'],
  data: () => ({
    gender_list: [
      { label: 'Female', value: 'female' },
      { label: 'Male', value: 'male' }
    ],
    marriage_status_list: [
      { label: 'Single', value: 'Single' },
      { label: 'Married', value: 'Married' },
      { label: 'Divorce', value: 'Divorced' }
    ],
    nationality_list: [
      { label: 'Thai', value: 'Thai'},
      { label: 'Filipino', value: 'Filipino'},
      { label: 'Myanmar', value: 'Myanmar'},
      { label: 'Myanmar/Thaiyai', value: 'Myanmar/Thaiyai'},
      { label: 'Lao', value: 'Lao'},
      { label: 'Cambodian', value: 'Cambodian'},
      { label: 'Vietnamese', value: 'Vietnamese'},
    ],
    religion_list: [
      { label: 'Buddhist', value: 'Buddhist' },
      { label: 'Christian', value: 'Christian' },
      { label: 'Muslim', value: 'Muslim' },
      { label: 'Sikhs', value: 'Sikhs' },
      { label: 'None', value: '-' },
      { label: 'Other', value: 'Other' },
    ],
    religion: '',
    displayDate: false,
    expiration_date: null,
    displayReligion: false,
    displayExpireDate: false,
    rules: {
      profile_image: value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
      require: value => !!value || 'Please fill in information',
      personal_id: value => !value || value.length < 14 || 'Personal ID must have 13 digits',
    },
    img_base_url: process.env.VUE_APP_IMG_BASE_URL
  }),
  methods: {
    displayDatepicker () {
      this.displayDate = !this.displayDate
    },
    displayExpirationDate () {
      this.displayExpireDate = !this.displayExpireDate
    },
    updateExpireDate () {
      this.personal_information.work_permit_expiration_date = this.expiration_date
      this.displayExpireDate = false
    },
    updateReligion (val) {
      this.displayReligion = (val == 'Other') ? true : false
      this.personal_information.religion = (val != 'Other') ? val : ''
    },
    async updateImage () {
      try {
        if (!this.personal_information.profile_image)
          return false
        else {
          await this.removeImage();
          let formData = new FormData()
          await formData.append('profile', this.personal_information.profile_image)

          const upload_result = await this.$http.post('/back-office/supporters/profile-image', formData, authHeader())
          if (upload_result) {
            this.personal_information.profile_image_url = upload_result.data.file_name
            this.image_src = `${this.img_base_url}/uploads/supporters/${this.personal_information.profile_image_url}`
            
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async removeImage () {
      try {
        if (!this.personal_information.profile_image || !this.personal_information.profile_image_url)
          return;
        else {
          let image_url = this.personal_information.profile_image_url
          await this.$http.delete(`/back-office/supporters/profile-image/${image_url}`, authHeader())
          this.personal_information.profile_image_url = null
          return;
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
  computed: {
    age () {
      if (this.personal_information.birthdate) {
        const bdate = this.personal_information.birthdate.split('-')
        const birthdate = new Date(Number(bdate[0]), Number(bdate[1])-1, Number(bdate[2]))
        const today = new Date()
        let age = today.getFullYear() - birthdate.getFullYear()
        const month = today.getMonth() - birthdate.getMonth()
        if (month < 0 || (month === 0 && today.getDate() < birthdate.getDate())) {
          age--
        }
        return age
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped>
  .no-padding-vertical {
    padding-top: 0;
    padding-bottom: 0;
  }
</style>